import { gql } from '@apollo/client';

export const CREATE_NORMAL_PRODUCT = gql`
 mutation CreateProduct($name: String!, $type: ProductType!, $thumbnailUrl: String!, $categoryId: String!, $storeId: String!, $variants: [VariantInput!]!, $returnPolicy: String, $description: String, $shippingPolicy:String) {
  createProduct(name: $name, type: $type, thumbnail_url: $thumbnailUrl, categoryId: $categoryId, storeId: $storeId, variants: $variants, returnPolicy: $returnPolicy, description: $description,shippingPolicy: $shippingPolicy) {
    id
    name
    price
    returnPolicy
    shippingPolicy
  }
}
`;

export const CREATE_PRODUCT = gql`
  mutation CreateProduct(
    $name: String!
    $colors: [String!]!
    $sizes: [String!]!
    $images: [String!]!
    $price: String!
    $categoryId: String!
    $storeId: String!
    $description: String
    $tags: [String]
    $sku: String
    $brandId: String
  ) {
    createProduct(
      name: $name
      colors: $colors
      sizes: $sizes
      images: $images
      price: $price
      categoryId: $categoryId
      storeId: $storeId
      description: $description
      tags: $tags
      sku: $sku
      brandId: $brandId
    ) {
      id
      name
    }
  }
`;

export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct(
    $name: String!
    $colors: [String!]!
    $sizes: [String!]!
    $images: [String!]!
    $categoryId: String!
    $productId: String!
    $brandId: String
    $sku: String
    $tags: [String]
    $description: String
    $returnPolicy: String
    $shippingPolicy: String
  ) {
    updateProduct(
      name: $name
      colors: $colors
      sizes: $sizes
      images: $images
      categoryId: $categoryId
      productId: $productId
      brandId: $brandId
      sku: $sku
      tags: $tags
      description: $description
     returnPolicy: $returnPolicy
   shippingPolicy: $shippingPolicy
    ) {
      id
      name
    }
  }
`;

export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($productId: String!) {
    deleteProduct(productId: $productId)
    RemoveProductFromNewArrival(productId: $productId)
  }
`;


export const SYNC_CATEGORIES = gql`
mutation {
  syncCategories
}
`;
export const SYNC_PRODUCTS = gql`
mutation {
  syncProducts
}
`;

export const UPDATE_SERVICE = gql`
 mutation UpdateServiceProduct(
 $name: String!, 
 $thumbnailUrl: String!, 
 $categoryId: String!, 
 $variant: VariantInput!, 
 $productId: String!, 
 $description: String,
$returnPolicy: String,
$shippingPolicy: String,
 ) {
  updateServiceProduct(name: $name, thumbnail_url: $thumbnailUrl, categoryId: $categoryId, variant: $variant, productId: $productId, description: $description, returnPolicy: $returnPolicy,
   shippingPolicy: $shippingPolicy) {
    id
  }
}
`;

export const UPDATE_NORMAL_PRODUCT = gql`
  mutation UpdateProduct(
    $name: String!
    $thumbnailUrl: String!
    $categoryId: String!
    $productId: String!
    $description: String
    $returnPolicy: String
    $shippingPolicy: String
  ) {
    updateProduct(
      name: $name
      thumbnail_url: $thumbnailUrl
      categoryId: $categoryId
      productId: $productId
      description: $description
      returnPolicy: $returnPolicy
      shippingPolicy: $shippingPolicy
    ) {
      id
    }
  }
`;

export const CREATE_NEW_VARIANT = gql`
  mutation CreateVariant($variant: VariantInput!, $productId: String!) {
    createVariant(variant: $variant, productId: $productId) {
      id
    }
  }
`;

export const GET_PRODUCT_VARIANTS = gql`
  query AvailableProductVariants($productId: String!) {
    availableProductVariants(productId: $productId) {
      id
      thumbnail_url
      name
      availability_status
      color
      preview_url
      size
      sku
      currency
      price
      Product {
        id
        name
        type
        thumbnail
        description
returnPolicy
      shippingPolicy
        Category {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_VARIANT = gql`
  mutation ($variant: VariantInput!, $variantId: String!) {
    updateVariant(variant: $variant, variantId: $variantId) {
      id
    }
  }
`;

export const CHANGE_VARIANT_AVAILABILITY = gql`
  mutation ChangeVariantAvailabilty($variantId: String!, $availabilityStatus: String!) {
    changeVariantAvailabilty(
      variantId: $variantId
      availability_status: $availabilityStatus
    ) {
      id
      availability_status
    }
  }
`;

export const GET_PRODUCT_BY_ID = gql`
  query ProductById($productId: String!) {
    productById(productId: $productId) {
      Tags {
        id
        name
      }
      Store {
        id
        name
        profilePic
        description
        createdAt
        coverPic
      }
      colors
      createdAt
      description
      id
      images
      name
      price
      sizes
      sku
      avgRating
      totalReview
      Stock {
        id
        createdAt
        color
        Sizes {
          available
          end
          price
          size
          stock
        }
      }
      Category {
        id
        name
      }
      Brand {
        id
        name
      }
    }
  }
`;

export const GET_PRODUCTS = gql`
  query products($storeId: String) {
    products(storeId: $storeId, withoutPagination: true) {
      id
      name
      type
      thumbnail
      Variants {
     preview_url
      thumbnail_url
        id
      }
    }
  }
`;

export const GET_ALL_PRODUCT = gql`
  query products($storeId: String) {
    products(storeId: $storeId) {
      Brand {
        id
        name
      }
      Category {
        id
        name
      }
      Stock {
        id
        color
        Sizes {
          available
          end
          price
          size
          stock
        }
      }
      Store {
        id
        name
        profilePic
        description
        coverPic
        createdAt
      }
      Tags {
        id
        name
      }
      colors
      createdAt
      description
      NewArrival
      id
      images
      name
      price
      sizes
      sku
      avgRating
      totalReview
    }
  }
`;
